<div class="row">
    <div *ngIf="AllInvoices?.length==0;then NoInvoices else Invoices"></div>

    <ng-template #NoInvoices>
        <div class="col-md-12">
            <p> {{ 'NoDataFound' | translate }}</p>
        </div>
    </ng-template>

    <ng-template #Invoices>
        <div class="col-lg-4 col-sm-4 m-b-15" *ngFor="let invoice of AllInvoices">
            <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
                <mat-card-header class="mat-mdc-card-header bg-primary p-10 m-b-15">
                    <mat-card-title class="mat-mdc-card-title text-white">
                        {{ 'sequence' | translate }} :{{invoice.order}}
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content class="mat-mdc-card-content">
                    <div class="row">
                        <div class="col-md-9">
                            <table class="table w-100">
                                <tr>
                                    <td>
                                        <span class="spanTitle">{{ 'total' | translate }}:</span>
                                    </td>
                                    <td>
                                        <span> {{ invoice.totalWithInvoices |arabicPrice}}
                                            {{ 'EGP' | translate}}
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <span class="spanTitle">{{ 'invoicesDate' | translate }}:</span>
                                    </td>
                                    <td> <span> {{ invoice.invoicesDate|date:'yyyy/MM/dd'}}</span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <mat-divider></mat-divider>
                </mat-card-content>
                <mat-card-footer class="mat-mdc-card-header p-10 m-b-15">
                    <div class="row rowBtns">
                        <div class="col-sm-12">
                            <button mat-flat-button color="warn" class="DeleteOrderbtn"
                                (click)="DeleteOrder(invoice.id)">
                                {{ 'DeleteOrder' | translate }}
                            </button>

                            <button mat-flat-button class="ViewOrderbtn" (click)="ViewOrder(invoice)">
                                {{ 'ViewOrder' | translate }}
                            </button>
                        </div>
                    </div>
                </mat-card-footer>
            </mat-card>
        </div>
    </ng-template>
</div>